<div class="group-users__container" *transloco="let t">
  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="group-users__overview-wrapper">
    <app-inline-edit
      appEditOnEnter
      [control]="groupName"
      (update)="onNameUpdate()"
      class="group-users__name"
    >
      <ng-template appViewMode>
        <div class="group-users__name--view">
          {{ group?.group_name }}
        </div>
      </ng-template>

      <ng-template appEditMode>
        <mat-form-field>
          <input matInput appAutoFocus="100" [formControl]="groupName" [disabled]="isLoading" />

          @if (groupName.hasError('nameInvalid')) {
            <mat-error>{{ t('group-users.error.name-invalid') }}</mat-error>
          }
          @if (groupName.hasError('nameAlreadyExists')) {
            <mat-error>{{ t('group-users.error.name-already-exists') }}</mat-error>
          }
          @if (groupName.hasError('maxLength')) {
            <mat-error>{{ t('group-users.error.max-length') }}</mat-error>
          }
          @if (groupName.hasError('minLength')) {
            <mat-error>{{ t('group-users.error.min-length') }}</mat-error>
          }
        </mat-form-field>
      </ng-template>
    </app-inline-edit>
    <div class="group-users__details-and-actions-container">
      <div class="group-users__detail-container">
        <div class="group-users__detail kxi-text-normal">
          {{ t('group-users.created') }}
          <span class="kxi-text-600">{{ group?.creation_date | lexDate }}</span>
        </div>

        <div class="group-users__detail">
          {{ t('group-users.spotlight-projects')
          }}<span class="kxi-text-600">{{ groupProjectCount }}</span>
        </div>

        <div class="group-users__detail">
          {{ t('group-users.configurations') }}
          <span class="kxi-text-600">{{ groupConfigCount }}</span>
        </div>

        <div class="group-users__detail">
          {{ t('group-users.configuration-routes') }}
          <span class="kxi-text-600">{{ groupRouteCount }}</span>
        </div>
      </div>

      <div class="group-users__actions">
        <div class="group-users__reload-button">
          <xi-icon-button icon="refresh" (onClick)="onReloadGroup()"></xi-icon-button>
        </div>
        <div [matTooltip]="deleteButtonTooltip">
          <xi-icon-button
            icon="trash"
            [disabled]="isLoading || !canDeleteGroup"
            (onClick)="deleteGroup()"
          ></xi-icon-button>
        </div>
      </div>
    </div>
    <div class="group-users__horizontal-line"></div>
    <div>
      {{ t('group-users.id') }} {{ group?.group_id }}
      <xi-icon-button
        (click)="copyGroupId()"
        [tooltip]="{ text: t('group-users.copy-to-clipboard') }"
        color="CX"
        icon="copy"
      ></xi-icon-button>
    </div>
  </div>

  <app-group-permission-table
    [parent]="group"
    [parentAllUsers]="allUsers"
    [userMemberships]="userMemberships"
    [remainingItems]="remainingUsers"
    [tableData]="groupUsers"
    scrollbarHeight="40vh"
    [hasEmail]="true"
    [isLoading]="isLoading"
    (addItem)="onAddUser()"
    (itemRemoved)="onUserRemoved($event)"
    (permissionChanged)="onPermissionChanged()"
  >
  </app-group-permission-table>
</div>

<!--User Add Modal-->
@if (showGroupUsersModal) {
  <app-lex-xi-modal
    [isVisible]="showGroupUsersModal"
    [canBackdropClose]="false"
    maxWidth="990px"
    (close)="onGroupUsersModalClosed(null)"
  >
    <ng-template appXIModalContent>
      @if (showGroupUsersModal) {
        <app-user-add-dialog
          [data]="groupUsersData"
          (modalClosed)="onGroupUsersModalClosed($event)"
        ></app-user-add-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
